import { internalLinkStyle, underlineLinkStyle } from '@bingads-webui-campaign-react/common-styles';

import { disclaimerSettingsStyles } from './disclaimer-extensions-styles';

export const settingsCommonStyles = ({ palette }) => ({
  '& .language, & .bidding-strategy__container select.form-control': {
    width: 461,
  },

  '& .bidding-strategy__container': {
    '& .custom-param__key-field': {
      display: 'inline-block',
      width: 85,
      marginLeft: 5,
      marginRight: 5,
    },
    '& #currencyLabelTargetRoas': {
      display: 'inline',
    },
    '& #currencyLabelCostPerSale': {
      display: 'inline',
    },
  },

  '& .cashback-settings': {
    '& .cashback-percent-container': {
      display: 'flex',
      '& .form-control.cashback-option-select': {
        width: 180,
        marginRight: 10,
      },
      '& .cashback-input-container, & .cashback-inherit-container, & .inherit-cashback-value': {
        flex: 1,
        display: 'flex',
        '& input': {
          width: 90,
        },
        '& .input-group-addon': {
          width: 'auto',
          paddingTop: 8,
        },
      },
    },
  },

  '& .control-label': {
    lineHeight: 1.5,
    marginTop: 26,
  },
  '& .control-label#currencyLabelTargetCpa': {
    marginTop: 'auto',
    display: 'inline',
  },

  '& .control-label+.col-sm-4': {
    display: 'table',
    width: 'auto',
  },

  '& .location-targets': {
    '& .control-label': {
      marginTop: 33,
    },

    '& .form-horizontal': {
      '& > div:nth-child(2) .control-label': {
        marginTop: 10,
      },

      '& .location-target-physical-intent': {
        '& .control-label': {
          marginTop: '33px !important',
        },
      },
    },

    '& .form-group .col-sm-2': {
      display: 'block',
    },
  },

  '& #AdvancedBudgetOptions': {
    marginTop: 10,
  },

  '& .copy-campaign-settings': {
    minWidth: 400,
    marginBottom: 4,

    '& .copy-settings': {
      paddingLeft: 28,
    },
  },

  '& .checkbox, .radio': {
    padding: 0,
    height: 'auto',
  },

  '& .checkbox-inline': {
    marginLeft: 0,
  },

  '& .checkbox label': {
    display: 'inline-block',
  },

  '& .checkbox input[type="checkbox"], & .checkbox-inline input[type="checkbox"], & .radio input[type="radio"]': {
    float: 'left',
    marginTop: 3,
  },

  '& .multi-language-selector': {
    width: 542,

    '& .alert': {
      width: 'auto',
      lineHeight: 1.5,
      margin: '8px 0',
      padding: 8,
      boxShadow: 'none',
    },

    '& .alert-image': {
      marginTop: 3,
    },

    '& .description': {
      paddingLeft: 15,
    },


    '& .container-fluid': {
      margin: 0,
      padding: 0,
    },

    '& .target-suggested-language': {
      height: 32,
      display: 'table',
      background: `${palette.white}`,
      marginTop: 10,
      verticalAlign: 'middle',
      color: '#000000',
      border: '1px solid #8A8886',
      boxSizing: 'border-box',
      borderRadius: 2,
      padding: '0 16px',
      lineHeight: '30px',
      fontSize: 14,
      fontWeight: 600,
    },

    '& .checkbox-inline': {
      paddingTop: 8,
      paddingBottom: 8,
    },
    '& .alert-info.form-group': {
      '& .alert-info-inline': {
        ...internalLinkStyle({ palette, elementLocator: '> a', isGreyBackground: true }),
        '& > a:focus': {
          border: 0,
        },
      },
    },
    ...underlineLinkStyle({ palette, elementLocator: 'a.HelpTopic' }),
    '& a.HelpTopic:focus': {
      border: 0,
    },
  },

  '& .language-error-container .col-sm-2': {
    display: 'none',
  },

  '& .dsa-switch-container label .text': {
    'white-space': 'nowrap',
  },

  ...disclaimerSettingsStyles({ palette }),
});
